import React, { createContext, useContext, useState, useEffect } from 'react';
import { pb } from '../lib/pocketbaseClient';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const ALLOWED_ROLES = ['hr', 'admin', 'super_admin'];

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setUser(pb.authStore.model);
    setLoading(false);
    return pb.authStore.onChange(() => setUser(pb.authStore.model));
  }, []);

  const login = async (email, password) => {
    const authData = await pb.collection('users').authWithPassword(email, password);
    const role = authData.record?.role;
    if (!ALLOWED_ROLES.includes(role)) {
      throw new Error('Access denied. You are not authorized to use the HR panel.');
    }
    return authData;
  };

  const logout = () => pb.authStore.clear();

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};
